import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./style.scss";
import BodyText from "../../elements/body-text";
import { Heading, AccordionWrapper, Wrapper } from "../../elements";

export default function BecomeAMember({ heading, body, backgroundImage, options = [], preselectedIndex, accordion, children, optionSelectedChanged = () => {}, id }) {
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(preselectedIndex);
  useEffect(() => {
    setSelectedOptionIndex(preselectedIndex);
  }, [preselectedIndex]);

  const [userHasInteracted, setUserHasInteracted] = useState(
    options.map(() => {
      return false;
    })
  );

  const [topSectionBackgroundImage, setTopSectionBackgroundImage] = useState(`linear-gradient(270deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 50%), linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(
    ${backgroundImage})`);

  const onOptionSelected = (option, index) => {
    setSelectedOptionIndex(index);
    let userHasInteractedCopy = userHasInteracted;
    userHasInteractedCopy[index] = true;
    setUserHasInteracted(userHasInteractedCopy);
    setTopSectionBackgroundImage(null);
    //emit to parent
    optionSelectedChanged(option, index);
  };

  // preload images
  useEffect(() => {
    options.forEach(({ backgroundImage }) => {
      const img = new Image();
      img.src = backgroundImage.src;
      window[img.src] = img;
    });
  }, [options]);
  return (
    <div className="become-a-member" id={id}>
      <div
        className="top-section"
        style={{
          backgroundImage: topSectionBackgroundImage,
          backgroundSize: "cover"
        }}
      >
        {options.map((option, index) => {
          let imageclasses = classNames("background-image", {
            selected: index === selectedOptionIndex,
            initial: !userHasInteracted[index]
          });
          return (
            <div
              style={{
                backgroundImage: `linear-gradient(270deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 50%), linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(
                  ${option.backgroundImage.src})`
              }}
              className={imageclasses}
              key={index}
            />
          );
        })}
        <Heading {...heading} typographyClass="type-h2" className="title" />
        {body && body.value && <BodyText html={body.value} />}
        <form className="options-form">
          {options.map((option, index) => {
            let optionClasses = classNames("round-radio-option", {
              selected: selectedOptionIndex === index
            });

            return (
              <div key={index} className={optionClasses} id={option.id}>
                <input checked={index === selectedOptionIndex} type="radio" onChange={evt => onOptionSelected(option, index)} />
                <span className="top-text">{option.topText}</span>
                <span className="option-text">{option.text}</span>
              </div>
            );
          })}
        </form>
      </div>
      {accordion && accordion.heading && (
        <AccordionWrapper
          {...{
            ...accordion,
            heading: {
              ...accordion.heading,
              typographyClass: "type-top-menu"
            },
            headingOpen: {
              ...accordion.headingOpen,
              typographyClass: "type-top-menu"
            },
            open: accordion.open
          }}
        >
          {children &&
            children.map((item, index) => {
              return <Wrapper key={index} {...item} />;
            })}
        </AccordionWrapper>
      )}
    </div>
  );
}

BecomeAMember.propTypes = {
  heading: PropTypes.shape({
    type: PropTypes.object,
    className: PropTypes.string,
    /** This takes the component is RTF */
    html: PropTypes.object
  }),
  backgroundImage: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      backgroundImage: PropTypes.shape({ src: PropTypes.string }),
      topText: PropTypes.shape,
      text: PropTypes.string,
      label: PropTypes.string,
      value: PropTypes.string,
      id: PropTypes.string
    })
  ),
  preselectedIndex: PropTypes.number,
  accordion: PropTypes.shape({
    heading: PropTypes.shape({
      type: PropTypes.object,
      className: PropTypes.string,
      /** This takes the component is RTF */
      html: PropTypes.object
    }),
    headingOpen: PropTypes.object,
    children: PropTypes.node,
    open: PropTypes.bool
  }),
  children: PropTypes.array,
  optionSelectedChanged: PropTypes.func
};
